module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_tribe_text_sm-d1a9a2bf343e03400fbc65607785a205.svg";